export default __webpack_public_path__ + "static/media/heroImage.0cac2a4c.png";